import ModalController from "./modal_controller"

const normalize = (value) => value.trim().replace(/\s+/g, " ").toLocaleLowerCase()

// Guard przed usunięciem/dezaktywacją tokena integracyjnego (np. inconnector) — taki token
// utrzymuje integrację (KSeF itd.), więc wymagamy świadomego potwierdzenia.
export default class extends ModalController {
  static targets = [...ModalController.targets, "acknowledgeStep", "confirmStep", "confirmInput", "submitButton", "activeCheckbox"]
  static values = { ...ModalController.values, expected: String }

  open() {
    super.open()
    this.resetSteps()
  }

  resetSteps() {
    if (!this.hasAcknowledgeStepTarget) return

    this.acknowledgeStepTarget.classList.remove("hidden")
    this.confirmStepTarget.classList.add("hidden")
    this.confirmInputTarget.value = ""
    this.submitButtonTarget.disabled = true
  }

  acknowledge() {
    this.acknowledgeStepTarget.classList.add("hidden")
    this.confirmStepTarget.classList.remove("hidden")
    this.confirmInputTarget.focus()
  }

  // przepisywaną frazą bywa wielowyrazowa nazwa zakładki, więc wielkość liter i podwójne
  // spacje nie mogą blokować przycisku bez żadnego komunikatu
  verify() {
    this.submitButtonTarget.disabled = normalize(this.confirmInputTarget.value) !== normalize(this.expectedValue)
  }

  // klawiatura obsługiwana tylko przy otwartym modalu — kontroler może opinać cały formularz edycji
  handleOnKeydown(event) {
    if (this.containerTarget.classList.contains("hidden")) return

    super.handleOnKeydown(event)
  }

  // przy dezaktywacji potwierdzenie jest jednym kliknięciem, więc Enter zrywałby integrację
  // zanim ostrzeżenie zdąży zostać przeczytane; przy usuwaniu chroni przepisanie nazwy
  confirm() {
    if (this.hasActiveCheckboxTarget) return

    super.confirm()
  }

  // zamknięcie modala inaczej niż przyciskiem potwierdzenia (Anuluj/X/Esc/backdrop) = rezygnacja,
  // więc przywracamy checkbox — inaczej Zapisz po ucieczce z modala dezaktywowałby token
  hide(event) {
    super.hide(event)

    if (this.hasActiveCheckboxTarget) this.activeCheckboxTarget.checked = true
  }

  interceptSubmit(event) {
    // potwierdzenie jest jednorazowe — gdyby ten submit nie doszedł do skutku, kolejny
    // znów musi przejść przez modal
    if (this.confirmed) {
      this.confirmed = false
      return
    }
    if (!this.hasActiveCheckboxTarget) {
      console.error("[api-token-guard] brak targetu activeCheckbox — submit bez guardu")
      return
    }
    if (this.activeCheckboxTarget.checked) return

    event.preventDefault()
    this.open()
  }

  confirmDeactivate(event) {
    event.preventDefault()
    const form = this.element.querySelector("form")
    if (!form) {
      console.error("[api-token-guard] nie znaleziono formularza — dezaktywacja niemożliwa")
      return
    }

    this.confirmed = true
    form.requestSubmit()
  }
}
